import { DateTime } from 'luxon';
import { AppThunk } from '../../../store/rootReducer';
import { episodeMeasurementMetricSelector } from '../../episodeMeasurement/selectors/episode-measurement.selectors';
import { setRulerTimeStarted } from '../actions/analytics-info.actions';
import { MEASURE_EPISODE_DURATION } from '../analytics.constants';
import { getBaseProperties, track } from '../analytics.utils';

export const trackEpisodeMeasurement =
  (analyticsEventTrack = track): AppThunk =>
  (dispatch, getState) => {
    const episodeMeasurementInfo = episodeMeasurementMetricSelector(getState());
    dispatch(setRulerTimeStarted({ timestamp: DateTime.now().toMillis() }));
    const baseProperties = getBaseProperties(getState);
    if (baseProperties == null) {
      return null;
    }
    const { ecgId, userId, view } = baseProperties;

    analyticsEventTrack({
      name: MEASURE_EPISODE_DURATION,
      properties: {
        user_id: userId,
        ecg_id: ecgId,
        view,
        plot: 'hr' as const,
        value: episodeMeasurementInfo ?? '0s',
      },
    });
  };
